import { Layout, MacroData as MacroDataComponent } from "components"
export const MacroData = () => {
 return (
  <Layout>
   <MacroDataComponent />
  </Layout>
 )
}
